import { createContext } from "react";

export type ContainsDropOversContextData = {
	registerDropOver?(): () => void;
};

export const ContainsDropOversContext = createContext<ContainsDropOversContextData>({
	registerDropOver: undefined
});